// extracted by mini-css-extract-plugin
export default {"fieldToGroupByText":"_190pI _2kZNz"};